var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPushPinOff = function SvgPushPinOff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M7.62 8.68 2.47 3.53a.75.75 0 0 1 1.06-1.06l18 18a.75.75 0 1 1-1.06 1.06l-6.15-6.15v.48c0 .448-.178.878-.495 1.195L12.72 18.16a1.69 1.69 0 0 1-2.391 0l-2.215-2.214L4.53 19.53a.75.75 0 0 1-1.06-1.06l3.584-3.584-2.214-2.214a1.69 1.69 0 0 1 0-2.392l1.103-1.103h.001c.318-.32.75-.496 1.196-.496h.48Zm5.2 5.2v1.98a.19.19 0 0 1-.056.135L11.659 17.1a.19.19 0 0 1-.27 0L5.9 11.61a.19.19 0 0 1 0-.269l1.106-1.104.002-.002a.188.188 0 0 1 .133-.054h1.98l3.7 3.7ZM15.237 9.43l-.843.843 1.06 1.06 1.137-1.137 1.838.098c.479.026.947-.153 1.286-.492l.54-.54a1.69 1.69 0 0 0 0-2.391l-4.126-4.125a1.69 1.69 0 0 0-2.39 0l-.54.54c-.34.338-.52.805-.493 1.286v.001l.098 1.836-1.137 1.137 1.06 1.06.844-.843 1.666 1.667Zm1.388-.734 1.884.1a.192.192 0 0 0 .145-.055l.54-.54a.19.19 0 0 0 0-.268l-4.126-4.127a.19.19 0 0 0-.268 0l-.54.54a.186.186 0 0 0-.056.142v.003l.1 1.885 2.32 2.32Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPushPinOff);
export default ForwardRef;